<div class="container-fluid">
  <nz-card>
    <!-- <div class="row">
    <div class="col-md-12">
      <div class="float-right">
        <button nz-button nzType="primary" (click)="addNew()">
          <i nz-icon nzType="plus"></i>Add Country
        </button>
      </div>
    </div>
  </div> -->
    <div class="row mt-3">
      <div class="col-md-12">
        <app-data-grid
          id="gridContainer"
          style="width: 100%"
          [dataSource]="gridData"
          [searchPanel]="true"
          [filterRow]="true"
          [filterPanel]="true"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
          exportFileName="LMO Details"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
        >
          <app-grid-column
            caption="S.No"
            cellTemplate="serialNumberTemplate"
            [width]="70"
          ></app-grid-column>

          <app-grid-column
            dataField="cntry_nm"
            caption="Country Name"
          ></app-grid-column>

          <app-grid-column
            caption="Actions"
            cellTemplate="actionTemplate"
            [width]="100"
          ></app-grid-column>
          <ng-template appGridCell="actionTemplate" let-data="cell"
            ><div>
              <button
                nz-button
                nzType="primary"
                nzShape="circle"
                (click)="editRecord(data.data)"
              >
                <i nz-icon nzType="edit"></i>
              </button>
              <button
                nz-button
                nzType="danger"
                nzShape="circle"
                class="ml-2"
                (click)="deleteRecord(data.data)"
              >
                <i nz-icon nzType="delete"></i>
              </button></div
          ></ng-template>

          <ng-template appGridCell="serialNumberTemplate" let-data="cell"
            ><div>
              {{ data.rowIndex + 1 }}
            </div></ng-template
          >
        </app-data-grid>
      </div>
    </div>
  </nz-card>
</div>

<nz-drawer
  [nzVisible]="shwSidebar"
  [nzTitle]="sidebarHeading"
  (nzOnClose)="closeSidebar()"
  [nzWidth]="500"
>
  <ng-container *nzDrawerContent>
    @if (shwDeleteCnfrm == false) {
    <div>
      <form nz-form [formGroup]="countryForm" (ngSubmit)="submitForm()">
        <div class="row">
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-label>Country Name</nz-form-label>
              <nz-form-control>
                <input
                  nz-input
                  formControlName="cntry_nm"
                  placeholder="Enter country name"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <button
              nz-button
              nzType="primary"
              [nzLoading]="shwLdng"
              type="submit"
            >
              {{ editdata ? "Update" : "Save" }}
            </button>
            <button
              nz-button
              class="ml-2"
              type="button"
              (click)="closeSidebar()"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
    } @if (shwDeleteCnfrm == true) {
    <div>
      <nz-alert
        nzType="warning"
        nzMessage="Warning"
        nzDescription="You are about to delete the following record."
        nzShowIcon
      ></nz-alert>
      <div>
        <div>
          <table class="del-confirm-table">
            <tr class="row">
              <td class="col">Country</td>
              <td class="col">:{{ countryForm.value.cntry_nm }}</td>
            </tr>
          </table>
        </div>
        <div></div>
      </div>
      <div class="row">
        <button
          nz-button
          nzType="default"
          class="col m-5"
          (click)="shwDeleteCnfrm = false"
        >
          Cancel
        </button>
        <button
          nz-button
          nzType="primary"
          class="col m-5"
          nz-popconfirm
          nzPopconfirmTitle="Are you sure to delete country ?"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="confirmDelete()"
          (nzOnCancel)="shwDeleteCnfrm = false"
        >
          Delete
        </button>
      </div>
    </div>
    }
  </ng-container>
</nz-drawer>
